Registrable = require 'mixins/registrable'
HandleTextChange = require 'mixins/handle-text-change'

SmTextFieldComponent = Em.TextField.extend [
  Registrable
  HandleTextChange
]...,
  classNames: ['sm-text-field']

  didInsertElement: ->
    @_super()
    @$().on "wheel", (e) =>
      e.preventDefault()
      $(this).blur()

  willDestroyElement: ->
    @_super()
    @$().off "wheel"

  actions:
    focus: ->
      @$()?.focus()
      false

module.exports = App.SmTextFieldComponent = SmTextFieldComponent